/** Contractor trades, plus the general business page, with their own insurance landing page at /insurance/<slug>. */
export const INSURANCE_VERTICAL_SLUGS = [
  'hvac',
  'plumbing',
  'electrical',
  'landscaping',
  'construction',
  'business',
] as const

export type InsuranceVerticalSlug = (typeof INSURANCE_VERTICAL_SLUGS)[number]

export const INSURANCE_VERTICAL_PATHS = INSURANCE_VERTICAL_SLUGS.map((slug) => `/insurance/${slug}`)

/** Whether pathname is one of the trade pages, with or without a trailing slash. */
export function isInsuranceVerticalPath(pathname: string): boolean {
  return INSURANCE_VERTICAL_PATHS.includes(pathname.replace(/\/+$/, ''))
}
